import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useIntlContext } from '../contexts/intl-context';
import { getLocaleFromPath, localizePath, swapLocaleInPath } from '../i18n/locale-path';
import { SupportedLocale } from '../i18n';

export function useLocalizedPath() {
  const { locale } = useIntlContext();
  return useCallback((path: string) => localizePath(locale, path), [locale]);
}

export function useChangeLocale() {
  const navigate = useNavigate();
  const location = useLocation();
  const { locale, setLocale } = useIntlContext();

  return useCallback(
    (nextLocale: SupportedLocale) => {
      if (nextLocale === locale) {
        return;
      }
      setLocale(nextLocale);

      // Only rewrite the URL when it already has a /fr or /en prefix.
      // Bare QR paths (/:objCode) keep their URL; locale stays in context/storage.
      if (getLocaleFromPath(location.pathname)) {
        const nextPath = swapLocaleInPath(location.pathname, nextLocale);
        navigate(`${nextPath}${location.search}${location.hash}`, { replace: true });
      }
    },
    [locale, setLocale, navigate, location.pathname, location.search, location.hash]
  );
}
